import { useState, useEffect } from "react";
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}
export const useCookieConsent = () => {
  const [consent, setConsent] = useState<"granted" | "denied" | "unset">(
    "unset"
  );

  useEffect(() => {
    const storedConsent = localStorage.getItem("cookieConsent") as
      | "granted"
      | "denied"
      | null;
    if (storedConsent) {
      setConsent(storedConsent);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "granted");
    setConsent("granted");

    if (window.gtag) {
      window.gtag("consent", "update", {
        ad_storage: "granted",
        analytics_storage: "granted",
      });
    }
  };

  const rejectCookies = () => {
    localStorage.setItem("cookieConsent", "denied");
    setConsent("denied");
  };

  const hasConsented = consent === "granted";

  return {
    acceptCookies,
    rejectCookies,
    hasConsented,
    consent,
  };
};
